export default __webpack_public_path__ + "static/media/trojuhelnicky_nove.b3d1da13.png";